import clsx from "clsx";
import React from "react";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import { gettext } from "web/script/modules/django-i18n";
import styles from "./styles.module.css";

interface AppStoreDetailsProps {
    className?: string;
}

export default function AppStoreDetails({ className }: AppStoreDetailsProps): JSX.Element {
    return (
        <div className={clsx(styles.appStoreDetails, className)}>
            <p>{gettext("app_landing.rating.number")}</p>
            <div className={styles.stars}>
                <SVGIcon name="stars" />
            </div>
            <p className={styles.rating}>{gettext("app_landing.rating.label")}</p>
        </div>
    );
}
